// src/hooks/useSecondaryClick

import { useCallback } from 'react'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { useDispatch } from 'react-redux'
// @ts-expect-error TS6133 -- MIGRATION: not approved, fix when encountered
import { useNavigate } from 'react-router-dom'
import { deleteBooking } from '../../../store/new-visit/NewVisitActions'
import { AVAILABILITY_ROUTE } from '../../../utils/constants'

// @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
export const useSecondaryClick = ({ showReviewBook, state, bookingId, dispatch, navigate, setShowReviewBook }) => {
  const handleSecondaryClick = useCallback(() => {
    if (showReviewBook) {
      setShowReviewBook(false)
    } else if (state?.previousState) {
      navigate(-1)

      setTimeout(() => {
        if (bookingId?.current) {
          dispatch(deleteBooking(bookingId.current))
        }
      }, 1000)
    } else {
      navigate(AVAILABILITY_ROUTE)
    }
  }, [showReviewBook, state, bookingId, dispatch, navigate, setShowReviewBook])

  return handleSecondaryClick
}
